
















import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import Checkbox from "../../components/form/checkBox.vue";

@Component({
  components: { Checkbox },
})
export default class LegalCheck extends Vue {
  @Emit("input")
  onChange(val: any) {
    return val;
  }
}
